<div class="relative text-center">
  <aux-icon
    name="Message"
    class="text-aux-blue-dark"
    data-pendo-id="close-summary-review-notes-open-modal"
    [auxTooltip]="params.tooltip"
  />
  @if (!!this.params.value) {
    <span class="notes-badge">{{ this.params.value }}</span>
  }
</div>
